// Cronologia annulla/ripeti: ogni voce ha undo() e redo() asincroni che
// ripristinano lo stato (di solito chiamando l'API e ricaricando).

export function createHistory(limit = 60) {
  let undoStack = [];
  let redoStack = [];
  return {
    push(entry) {
      undoStack.push(entry);
      if (undoStack.length > limit) undoStack.shift();
      redoStack = [];
    },
    async undo() {
      const entry = undoStack.pop();
      if (!entry) return false;
      await entry.undo();
      redoStack.push(entry);
      return true;
    },
    async redo() {
      const entry = redoStack.pop();
      if (!entry) return false;
      await entry.redo();
      undoStack.push(entry);
      return true;
    },
    canUndo: () => undoStack.length > 0,
    canRedo: () => redoStack.length > 0,
    clear() {
      undoStack = [];
      redoStack = [];
    },
  };
}
